module.exports = __webpack_public_path__ + "img/flechaFooter-Active.bc5797a8.svg";